import React, { useEffect, useState } from 'react';
import { Modal, Form, Input, DatePicker, Button, Row, Col, message, Select } from 'antd';
import axiosInstance from '../../services/axiosInstance';
import { catchError } from '../../utils/errorHandler';
import moment from 'moment';
import usePermissions from '../../hooks/usePermissions';
import SpinLoading from '../../components/MyOrderActions/SpinLoading';

const { Option } = Select;


const ReportsInsights = ({ handleClose }) => {
    const [loading, setLoading] = useState({
        getDropdown: false,
        formSubmission: false
    });
    const [form] = Form.useForm();
    const { hasPermission } = usePermissions();
    const [dropDownData, setDropDownList] = useState([])
    const [userData, setUserData] = useState({})


    const handleFinish = async (values) => {
        setLoading(prev => ({
            ...prev,
            formSubmission: true
        }));
        try {
            const from_date = values.dates[0].format('YYYY-MM-DD');
            const to_date = values.dates[1].format('YYYY-MM-DD');
            const email = values.email || '';

            const params = {
                from_date,
                to_date,
                email,
            };


            const response = await axiosInstance.get('/task/v2/bdm-sheet/', {
                params,
                responseType: 'blob'
            });


            if (response.status === 200) {
                // ✅ Handle file download
                const blob = new Blob([response.data], {
                    type: response.headers['content-type'],
                });

                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = `${moment().format('DD-MM-YYYY hh:mm A')}`;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                window.URL.revokeObjectURL(url);
                message.success("Sheet Download Successfully")
                handleClose()

                return { success: true };
            } else {
                message.success("Something went wrong")
                setLoading(prev => ({
                    ...prev,
                    formSubmission: false
                }));
            }
        } catch (err) {
            if (err?.response?.status === 403) {
                message.error("Access forbidden. This user is not a BDM.");
                return;
            }
            if (
                err?.response?.data instanceof Blob &&
                err?.response?.headers['content-type']?.includes('application/json')
            ) {
                const reader = new FileReader();
                reader.onload = () => {
                    try {
                        const errorJson = JSON.parse(reader.result);
                        const errorMsg =
                            errorJson?.message ||
                            errorJson?.detail ||
                            'Something went wrong while downloading the sheet.';
                        message.error(errorMsg);
                    } catch (parseErr) {
                        message.error("An unknown error occurred.");
                    }
                };
                reader.readAsText(err.response.data);
            }
        } finally {
            setLoading(prev => ({
                ...prev,
                formSubmission: false
            }));
        }
    };

    const fetchDropdownList = async () => {
        setLoading(prev => ({
            ...prev,
            getDropdown: true
        }));
        try {
            // const res = await axiosInstance.get("/task/v2/bdm-sheet/memebers/dropdown/")
            const res = await axiosInstance.get("/analytics/team/hierarchy/?flat=True&permission=can_view_bdm_analytics")
            if (res.status === 200) {
                setDropDownList(res.data.data.hierarchy || [])
                setUserData({
                    user: res.data.data.user,
                    email: res.data.data.email,
                })
                setLoading(prev => ({
                    ...prev,
                    getDropdown: false
                }));
            }

        } catch (err) {
            console.log(err)
            setLoading(prev => ({
                ...prev,
                getDropdown: false
            }));
        }
    }

    useEffect(() => {
        if (hasPermission("can_download_any_bdm_sheet")) {
            fetchDropdownList()
        }
    }, [])

    if (loading.getDropdown) {
        return <SpinLoading tip="Loading status options..." style={{ display: 'block', marginTop: '0' }} />;
    }

    return (
        <Form
            form={form}
            layout="vertical"
            onFinish={handleFinish}
        >
            <Row style={{ width: "100%" }}>
                {(hasPermission("can_download_bdm_sheet") || hasPermission("can_download_any_bdm_sheet")) && (
                    <Col span={24}>
                        <Form.Item
                            label="Select Date Range"
                            name="dates"
                            rules={[{ required: true, message: 'Please select date range' }]}
                        >
                            <DatePicker.RangePicker style={{ width: "100%" }} />
                        </Form.Item>
                    </Col>
                )}

            </Row>
            <Row style={{ width: "100%" }}>
                {hasPermission("can_download_any_bdm_sheet") && (
                    <Col span={24}>
                        <Form.Item
                            label="Members"
                            name="email"
                            rules={[{ required: true, message: 'Please select a member' }]}
                        >
                            <Select
                                placeholder="Select a member"
                                showSearch
                                optionFilterProp="label"
                                filterOption={(input, option) =>
                                    option.label.toLowerCase().includes(input.toLowerCase())
                                }
                            >
                                {userData?.email && (
                                    <Option key={userData.email} value={userData.email} label={userData.user}>
                                        {userData.user}  (You)
                                    </Option>
                                )}
                                {dropDownData.map((member) => (
                                    <Option key={member.email} value={member.email} label={member.user}>
                                        {member.user}
                                    </Option>
                                ))}
                            </Select>
                        </Form.Item>
                    </Col>
                )}
            </Row>
            <div style={{ width: "100%", display: "flex", justifyContent: "flex-end" }}>
                <Button type="primary" htmlType="submit" loading={loading.formSubmission}>
                    Submit
                </Button>
            </div>
        </Form>
    );
};

export default ReportsInsights;